import { useState } from "react";
import { useAuthStatus, useAuthToken } from "@/contexts/OptimizedAuthContext";
import { getCLIAuthCode } from "@/services/api";

export const useCLIAuthToken = () => {
  const [loading, setLoading] = useState<boolean | undefined>(undefined);
  const [error, setError] = useState<string | null>(null);
  const [code, setCode] = useState<string | null>(null);
  const [expiresAt, setExpiresAt] = useState<string | null>(null);
  const [success, setSuccess] = useState<boolean | null>(null);

  const getToken = useAuthToken();
  const { isSignedIn, isLoaded } = useAuthStatus();

  const fetchAuthCode = async () => {
    if (isLoaded && !isSignedIn) {
      setSuccess(false);
      setError("User is not signed in");
      return;
    }

    try {
      setLoading(true);
      setError(null);

      // Get the Clerk token with the specstory_cloud template
      const token = await getToken({ template: "specstory_cloud" });

      if (!token) {
        // throw new Error("Failed to get authentication token");
        setError("Failed to get authentication token");
        setLoading(false);
        setSuccess(false);
        return;
      }

      const response = await getCLIAuthCode(token);
      setSuccess(response.success);
      if (!response.success) {
        // throw new Error(response.error || "Failed to get auth code");
        setError(response.error || "Failed to get auth code");
      } else {
        setCode(response.response?.code || null);
        setExpiresAt(response.response?.expiresAt || null);
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to get auth code");
    } finally {
      setLoading(false);
    }
  };
  if (loading === undefined) {
    setLoading(true);
    void fetchAuthCode();
  }

  return { success, code, expiresAt, loading, error, fetchAuthCode };
};
